import { z } from "zod";

export const FormSchema = z
  .object({
    state: z
      .string({ required_error: "Selecione uma UF válida." })
      .nonempty("Selecione uma UF válida."),
    tip: z
      .string({ required_error: "Selecione um tipo de tributo." })
      .nonempty("Selecione um tipo de tributo."),
    alq: z
      .string({ required_error: "Alíquota é obrigatória." })
      .nonempty("Alíquota é obrigatória."),
    cst: z
      .string({ required_error: "CST é obrigatório." })
      .nonempty("CST é obrigatório.")
      .length(3, "CST deve ter 3 caracteres."),
    cfop: z
      .string()
      .optional()
      .refine((val) => !val || val.length === 4, {
        message: "CFOP deve ter 4 caracteres.",
      }),
    classification_tax: z
      .string()
      .optional()
      .refine((val) => !val || val.length === 6, {
        message: "Classificação Tributária deve ter 6 caracteres.",
      }),
    initial_term: z
      .string({ required_error: "Selecione uma data inicial." })
      .nonempty("Selecione uma data inicial."),
    final_term: z.string().optional(),
  })
  .refine(
    (data) => {
      const tip = data.tip;
      if (tip === "1" && !data.cfop) {
        return false;
      }
      return true;
    },
    {
      message: "CFOP é obrigatório para ICMS.",
      path: ["cfop"],
    }
  )
  .refine(
    (data) => {
      const tip = data.tip;
      if ((tip === "6" || tip === "7") && !data.classification_tax) {
        return false;
      }
      return true;
    },
    {
      message: "Classificação Tributária é obrigatória para IBS e CBS.",
      path: ["classification_tax"],
    }
  )
  .superRefine((data, ctx) => {
    const initial = new Date(data.initial_term);
    const final = data.final_term ? new Date(data.final_term) : null;

    const issues = [
      !(initial instanceof Date && initial.toString() !== "Invalid Date") && {
        path: ["initial_term"],
        code: "custom",
        message: "Data inicial inválida",
      },
      final &&
        !(final instanceof Date && final.toString() !== "Invalid Date") && {
          path: ["final_term"],
          code: "custom",
          message: "Data final inválida",
        },
      final &&
        initial instanceof Date &&
        final instanceof Date &&
        initial.toString() !== "Invalid Date" &&
        final.toString() !== "Invalid Date" &&
        final < initial && {
          path: ["final_term"],
          code: "custom",
          message: "Data final deve ser posterior à inicial",
        },
    ].filter(Boolean) as z.ZodIssue[];

    issues.forEach((issue) => ctx.addIssue(issue));
  });
